module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('h4', {
    staticClass: "margin-t-z margin-b-s"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.custInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "customer-info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.name')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.customer.firstName) + " " + _vm._s(_vm.customer.lastName))])]), _vm._v(" "), _c('div', {
    staticClass: "customer-info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.email')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.customer.email))])]), _vm._v(" "), _c('div', {
    staticClass: "customer-info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.phone')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.customer.phones[0].countryCode) + _vm._s(_vm.customer.phones[0].phoneNumber))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-271ac535", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-271ac535","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RsvpEdit/CustomerInformation.vue
// module id = 2058
// module chunks = 0